"use client";
import { ErrorAlert } from "@components/CustomAlert";
import { requestAlegriia } from "@utils/requests";
import axios, { AxiosError } from "axios";
import { useCallback, useEffect } from "react";
import { useShallow } from "zustand/react/shallow";
import { useRestaurant } from "../../core/hooks/endpoints/useRestaurant";
import { useStore } from "../../core/store";

export const SubscribeTopics = () => {
  const { notificationToken, setTopic, topic } = useStore(
    useShallow((state) => ({
      notificationToken: state.notificationToken,
      setTopic: state.setTopic,
      topic: state.topic,
    }))
  );
  const { restaurant } = useRestaurant();

  const subscribeTopic = useCallback(
    async (token: string, newTopic: string) => {
      try {
        await requestAlegriia.post(
          "/notifications/newTopic",
          { tokenFCM: token, topic: newTopic },
          {
            headers: { Authorization: token },
          }
        );
        setTopic?.(undefined);
      } catch (err) {
        const error = err as Error | AxiosError;
        console.log(error);
        ErrorAlert(
          axios.isAxiosError(error)
            ? error.response?.data?.error?.toString()
            : error.toString()
        );
      }
    },
    [setTopic]
  );

  useEffect(() => {
    if (notificationToken) {
      //Aquí se pondrán todos los temas a los que se subscribirá para enviar las notificationes
      if (topic === "restaurant" && restaurant) {
        const addresses = restaurant.addresses ?? [];
        if (addresses.length === 0) return setTopic?.(undefined);
        subscribeTopic(
          notificationToken,
          `${restaurant.idRestaurant}-${restaurant.name}`.replaceAll(" ", "")
        );
      }
    }
  }, [subscribeTopic, setTopic, notificationToken, topic, restaurant]);
  return null;
};
